module.exports = __webpack_public_path__ + "resource/img/banner_clause.jpg?c918f91641fd021bef8aaaff6e8b1eb4";


//////////////////
// WEBPACK FOOTER
// ./src/images/banner_clause.jpg
// module id = 192
// module chunks = 36